import template from './new-big-theme.html';
import themes from '../themes/themes';

export default {
	name: 'NewBigTheme',
	template,
	props: ['theme', 'data', 'backgroundUrl', 'fontFamily'],
	data () {
		return {
			themes
		};
	}
};
